function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: #bcbcbc;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #ffbe00;\n      }"));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  id: "canvas_background",
  height: 205,
  width: 520,
  y: -1,
  x: -1
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
  d: "m126.089,3.511l-29.9,0a1.572,1.572 0 0 0 -1.568,1.577l0,128.6c0,23.573 -11.244,37.646 -30.081,37.646c-17.912,0 -28.87,-13.343 -29.512,-35.789a1.565,1.565 0 0 0 -1.541,-1.545l-29.894,0a1.614,1.614 0 0 0 -1.6,1.643c0.919,39.316 25.878,65.629 62.545,65.629c37.752,0 63.115,-27.16 63.115,-67.586l0,-128.6a1.572,1.572 0 0 0 -1.568,-1.577",
  className: "cls-1",
  id: "J"
}), /*#__PURE__*/React.createElement("path", {
  d: "m260.923,170.157c-36.8,0 -66.741,-30.576 -66.741,-68.156s29.941,-68.158 66.741,-68.158s66.741,30.577 66.741,68.157s-29.94,68.156 -66.741,68.156m0,-169.158c-54.441,0 -98.734,45.306 -98.734,101s44.293,101 98.734,101s98.732,-45.31 98.732,-101s-44.29,-101 -98.732,-101",
  className: "cls-1",
  id: "O"
}), /*#__PURE__*/React.createElement("path", {
  d: "m451.739,100.006l-52.834,-95.929a1.566,1.566 0 0 0 -1.37,-0.813l-36.968,0a1.578,1.578 0 0 0 -1.366,2.353l58.553,104.2a23.168,23.168 0 0 1 3.381,12.063l0,78.431a1.573,1.573 0 0 0 1.568,1.577l29.524,0a1.572,1.572 0 0 0 1.568,-1.577l0,-92.934a14.172,14.172 0 0 0 -2.056,-7.371",
  className: "cls-1",
  id: "Y"
}), /*#__PURE__*/React.createElement("path", {
  d: "m69.934,3.511l-33.324,0a1.583,1.583 0 0 0 -1.579,1.589l0,29.777a1.583,1.583 0 0 0 1.579,1.589l33.324,0a1.585,1.585 0 0 0 1.58,-1.589l0,-29.777a1.585,1.585 0 0 0 -1.58,-1.589",
  className: "cls-2",
  id: "J_Dot"
}), /*#__PURE__*/React.createElement("path", {
  d: "m514.4,3.264l-36.874,0a1.565,1.565 0 0 0 -1.372,0.815l-16.354,29.783a1.59,1.59 0 0 0 1.384,2.358l36.867,0a1.568,1.568 0 0 0 1.374,-0.815l16.358,-29.783a1.59,1.59 0 0 0 -1.383,-2.358",
  className: "cls-2",
  id: "Y_Dot"
}));

var SvgJoyLogoGray = function SvgJoyLogoGray(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_Gray",
    width: 518,
    height: 203,
    viewBox: "0 0 518 203",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoyLogoGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/joy-logo-gray.7d75d60f.svg";
export { ForwardRef as ReactComponent };